import React from "react";
import { Thumbnail, Text, Button, Stack } from "@tiendanube/components";

function IFrameSkeleton({ height: h, width: w }: { height: number, width: number }): JSX.Element {
    const height = `${h}px`;
    const width = `${w + 16}px`;
    const widthImg = `${w}px`;
    return <div style={{ height, width }}>
        <Stack column justify="center" spacing='tight' >
            <Stack.Item >
                <Thumbnail.Skeleton width={widthImg} />
            </Stack.Item >
            <Stack.Item >
                <Text.Skeleton width="medium" size="base" />
            </Stack.Item>
            <Stack.Item >
                <Text.Skeleton width="medium" size="base" />
            </Stack.Item>
            <Stack.Item >
                <Button.Skeleton />
            </Stack.Item>
            <Stack.Item >
                <Text.Skeleton width="medium" size="base" />
            </Stack.Item>
        </Stack>
    </div>
};

export default IFrameSkeleton